"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var utils_1 = require("../../utils");
var colors_1 = require("../../constants/colors");
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var AXSButton_1 = __importDefault(require("../AXSButton"));
var AXSToggleGroup_1 = require("../AXSToggleGroup");
var AXSToggle_1 = __importDefault(require("../AXSToggle"));
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: max-content;\n"], ["\n  position: relative;\n  width: max-content;\n"])));
var Panel = styled_components_1.default(AXSBlock_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  position: absolute;\n  right: 0;\n  top: 60px;\n  z-index: 1;\n\n  &:before {\n    border: 10px solid transparent;\n    border-bottom-color: ", ";\n    content: ' ';\n    height: 0;\n    position: absolute;\n    right: 15px;\n    top: -20px;\n    width: 0;\n  }\n"], ["\n  background-color: ", ";\n  position: absolute;\n  right: 0;\n  top: 60px;\n  z-index: 1;\n\n  &:before {\n    border: 10px solid transparent;\n    border-bottom-color: ", ";\n    content: ' ';\n    height: 0;\n    position: absolute;\n    right: 15px;\n    top: -20px;\n    width: 0;\n  }\n"])), function (_a) {
    var dropBackgroundColor = _a.dropBackgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(dropBackgroundColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var dropBackgroundColor = _a.dropBackgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(dropBackgroundColor, theme, colors_1.colors.BLUE_300);
});
var ListOption = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n   &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n  padding: 16px;\n  font-size: 13px;\n  margin: 0;\n  color: ", ";\n  background-color: ", ";\n"], ["\n   &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n  padding: 16px;\n  font-size: 13px;\n  margin: 0;\n  color: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var selectOptionsBackgroundColorHover = _a.selectOptionsBackgroundColorHover, theme = _a.theme;
    return utils_1.parseThemePath(selectOptionsBackgroundColorHover, theme, colors_1.colors.GREY_150);
}, function (color) { return color; }, function (_a) {
    var selectedOptionBackgroundColor = _a.selectedOptionBackgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(selectedOptionBackgroundColor, theme, colors_1.colors.GREY_150);
});
var StyledIcon = styled_components_1.default(AXSIcon_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-right: 2px;\n"], ["\n  margin-right: 2px;\n"])));
var StyledButton = styled_components_1.default(AXSButton_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
});
var StyledToggleGroup = styled_components_1.default(AXSToggleGroup_1.AXSToggleGroup)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-bottom: 20px;\n"], ["\n  margin-bottom: 20px;\n"])));
var AXSDropSelect = /** @class */ (function (_super) {
    __extends(AXSDropSelect, _super);
    function AXSDropSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false,
            activeSelections: [],
            label: _this.props.label,
            selectedListOption: {},
            selections: _this.props.options,
        };
        _this.toggleSelectAll = function () {
            var selections = _this.state.selections;
            var newSelections = [];
            var activeSelections = [];
            if (selections.length === _this.countSelectedItems()) {
                newSelections = selections.map(function (item) {
                    return item;
                });
            }
            else {
                newSelections = selections.map(function (item) {
                    item.enabled = true;
                    activeSelections.push(item.value);
                    return item;
                });
            }
            _this.setState(function () {
                return { selections: selections, activeSelections: activeSelections };
            });
            return newSelections;
        };
        _this.countSelectedItems = function () {
            var selections = _this.state.selections;
            return selections.filter(function (item) { return item.enabled; }).length;
        };
        _this.renderToggleLabel = function () {
            var _a = _this.props, toggleLabel = _a.toggleLabel, toggleLabelColor = _a.toggleLabelColor, theme = _a.theme;
            return (React.createElement(AXSBlock_1.default, { color: utils_1.parseThemePath(toggleLabelColor, theme, colors_1.colors.WHITE), fontWeight: "700", marginBottom: "16px" }, toggleLabel));
        };
        _this.renderCheckboxes = function () {
            var _a = _this.props, dropBackgroundWidth = _a.dropBackgroundWidth, dropBackgroundColor = _a.dropBackgroundColor, toggleBorderColor = _a.toggleBorderColor, toggleBorderColorHover = _a.toggleBorderColorHover, toggleCheckColor = _a.toggleCheckColor, toggleCheckBackgroundColor = _a.toggleCheckBackgroundColor, toggleLabel = _a.toggleLabel, toggleLabelColor = _a.toggleLabelColor, handleSelections = _a.handleSelections, theme = _a.theme, direction = _a.direction;
            var selections = _this.state.selections;
            return (React.createElement(Panel, { dropBackgroundColor: utils_1.parseThemePath(dropBackgroundColor, theme, colors_1.colors.BLUE_300), padding: "16px 16px 4px 16px", width: dropBackgroundWidth },
                toggleLabel ? _this.renderToggleLabel() : null,
                React.createElement(StyledToggleGroup, { direction: direction, name: "toggleGroup", handleChange: function (selections, lastSelection) {
                        if (lastSelection.value === 'all' && lastSelection.enabled) {
                            var toggledSelections = _this.toggleSelectAll();
                            handleSelections(toggledSelections, lastSelection);
                        }
                        else if (lastSelection.value !== 'all' && !lastSelection.enabled) {
                            var clonedSelections = __spreadArrays(selections);
                            _this.setState({ selections: clonedSelections });
                            handleSelections(clonedSelections, lastSelection);
                        }
                        else {
                            _this.setState({ selections: selections });
                            handleSelections(selections, lastSelection);
                        }
                    } }, selections.map(function (option) {
                    return (React.createElement(AXSToggle_1.default, { enabled: option.enabled, label: option.label, labelColor: utils_1.parseThemePath(toggleLabelColor, theme, colors_1.colors.WHITE), toggleBorderColor: utils_1.parseThemePath(toggleBorderColor, theme, colors_1.colors.WHITE), toggleBorderColorHover: utils_1.parseThemePath(toggleBorderColorHover, theme, colors_1.colors.WHITE), toggleCheckBackgroundColor: utils_1.parseThemePath(toggleCheckBackgroundColor, theme, colors_1.colors.BLUE_300), toggleCheckColor: utils_1.parseThemePath(toggleCheckColor, theme, colors_1.colors.WHITE), value: option.value, key: "drop-select" + option.value }));
                }))));
        };
        _this.createListOptions = function () {
            var _a = _this.props, selectOptionsBackgroundColorHover = _a.selectOptionsBackgroundColorHover, toggleLabelColor = _a.toggleLabelColor, theme = _a.theme, selectedOptionBackgroundColor = _a.selectedOptionBackgroundColor, dropBackgroundColor = _a.dropBackgroundColor;
            var selections = _this.state.selections;
            var listOptions = [];
            selections.forEach(function (option) {
                listOptions.push(React.createElement(ListOption, { selectOptionsBackgroundColorHover: selectOptionsBackgroundColorHover, color: utils_1.parseThemePath(toggleLabelColor, theme, colors_1.colors.WHITE), onClick: function () { return _this.handleListOptionSelection(option); }, selectedOptionBackgroundColor: option.enabled ? selectedOptionBackgroundColor : dropBackgroundColor }, option.label));
            });
            return listOptions;
        };
        _this.handleListOptionSelection = function (givenOption) {
            var handleListSelection = _this.props.handleListSelection;
            var selections = _this.state.selections;
            var newSelections = selections.map(function (option) {
                if (option.value === givenOption.value) {
                    option.enabled = true;
                }
                else {
                    option.enabled = false;
                }
                return option;
            });
            handleListSelection(givenOption);
            _this.setState({
                active: false,
                label: givenOption.label,
                selectedListOption: givenOption,
                selections: newSelections,
            });
        };
        _this.renderList = function () {
            var _a = _this.props, dropBackgroundWidth = _a.dropBackgroundWidth, dropBackgroundColor = _a.dropBackgroundColor, theme = _a.theme, toggleLabel = _a.toggleLabel;
            return (React.createElement(Panel, { dropBackgroundColor: utils_1.parseThemePath(dropBackgroundColor, theme, colors_1.colors.BLUE_300), padding: "0", width: dropBackgroundWidth },
                toggleLabel ?
                    React.createElement(AXSBlock_1.default, { paddingLeft: "16px", paddingRight: "16px", paddingTop: "16px" }, _this.renderToggleLabel())
                    :
                        null,
                _this.createListOptions()));
        };
        _this.renderOptions = function () {
            var variant = _this.props.variant;
            return variant === 'checkboxes' ? _this.renderCheckboxes() : _this.renderList();
        };
        return _this;
    }
    AXSDropSelect.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.options !== prevProps.options) {
            this.setState({ selections: __spreadArrays(this.props.options) });
        }
    };
    AXSDropSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, width = _a.width, className = _a.className, color = _a.color, colorHover = _a.colorHover, backgroundHover = _a.backgroundHover, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderColorHover = _a.borderColorHover, borderRadius = _a.borderRadius, icon = _a.icon, iconColor = _a.iconColor;
        var _b = this.state, active = _b.active, label = _b.label;
        return (React.createElement(react_outside_click_handler_1.default, { onOutsideClick: function () { return _this.setState({ active: false }); } },
            React.createElement(Wrapper, { className: classnames_1.default(['c-axs-drop-select', className]) },
                React.createElement(StyledButton, { backgroundColor: backgroundColor, backgroundHover: backgroundHover, borderColor: borderColor, borderColorHover: borderColorHover, borderRadius: borderRadius, color: color, colorHover: colorHover, onClick: function () { return _this.setState({ active: !active }); }, size: "auto", variation: "dropButton", width: width },
                    React.createElement(AXSFlex_1.default, { justifyContent: "space-between", flexDirection: "row" },
                        React.createElement(AXSFlexItem_1.default, null,
                            icon && React.createElement(StyledIcon, { name: icon, color: iconColor }),
                            label),
                        React.createElement(AXSFlexItem_1.default, null,
                            React.createElement(AXSIcon_1.default, { name: active ? 'keyboard-arrow-up' : 'keyboard-arrow-down', color: iconColor, size: "24px" })))),
                active ? this.renderOptions() : null)));
    };
    AXSDropSelect.defaultProps = {
        backgroundColor: 'axsui.components.dropButton.primary.backgroundColor',
        backgroundHover: 'axsui.components.dropButton.primary.backgroundHover',
        borderColor: 'axsui.components.dropButton.primary.borderColor',
        borderColorHover: 'axsui.components.dropButton.primary.borderColorHover',
        borderRadius: 'axsui.components.dropButton.primary.borderRadius',
        className: undefined,
        color: 'axsui.components.dropButton.primary.color',
        colorHover: 'axsui.components.dropButton.primary.colorHover',
        direction: 'column',
        dropBackgroundColor: 'axsui.components.dropButton.primary.dropBackgroundColor',
        dropBackgroundWidth: 'axsui.components.dropButton.primary.dropBackgroundWidth',
        iconColor: 'axsui.components.dropButton.primary.toggleLabelColor',
        selectOptionsBackgroundColorHover: 'axsui.forms.selectOptionsBackgroundColorHover',
        selectedOptionBackgroundColor: 'axsui.forms.selectOptionsBackgroundColorHover',
        toggleBorderColor: 'axsui.components.dropButton.primary.toggleBorderColor',
        toggleBorderColorHover: 'axsui.components.dropButton.primary.toggleBorderColorHover',
        toggleCheckBackgroundColor: 'axsui.components.dropButton.primary.toggleCheckBackgroundColor',
        toggleCheckColor: 'axsui.components.dropButton.primary.toggleCheckColor',
        toggleColor: 'axsui.components.dropButton.primary.toggleColor',
        toggleLabel: '',
        toggleLabelColor: 'axsui.components.dropButton.primary.toggleLabelColor',
        toggleWidth: 'auto',
        variant: 'checkboxes',
        width: 'auto',
    };
    return AXSDropSelect;
}(React.Component));
exports.default = styled_components_1.withTheme(AXSDropSelect);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map